import styles from '../../../../terminals/list/list.module.css';
import { TerminalListTabsProps } from './terminal-list-tabs.type';

export const TerminalListTabs = ({
  tabs,
  value,
  counts,
  onChange,
}: TerminalListTabsProps) => {
  return (
    <div className={styles.tabs}>
      {tabs.map((tab) => {
        const isActive = value === tab.key;

        return (
          <button
            key={tab.key}
            className={`${styles.tab} ${isActive ? styles['tab-active'] : ''}`}
            onClick={() => onChange(tab.key)}
          >
            <span>{tab.label}</span>

            {counts[tab.key] !== null && (
              <span className={styles['tab-counter']}>
                {counts[tab.key]}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
};